import '../App.css';

import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import { DTPMessage } from 'meu-inss-ds';
import { WorkInProgress, ServicoNaoEncontradoScreen } from 'shared/template/InfoScreen';
import { estaLogado, isSessaoValida } from 'login/helper';
import { lazy, Suspense, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import { PainelProcurador } from './component/PainelProcurador';
import { Redirect, Switch, useLocation } from "react-router-dom";
import { setMensagemErro } from '../painel/actions';
import Breadcrumb from './component/breadcrumb';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import HideHelo from 'shared/component/HideHelo';
import history from '../history';
import LoadingCircular from 'shared/template/LoadingCircular';
import '../App.css';
import Route from "../CustomRoute";
import PrivateRoute from "../PrivateRoute";
import MIToolbar from "./component/toolbar";
import SkipLinkHome from 'shared/component/ds-govbr/SkiplinkHome';
import useCXPageView from 'shared/component/useCXPageView';
import { useExternalLinkHandler } from './component/feedback/useExternalLinkHandler';
import { getConfig } from "../ext-libs/firebase";

const Ajuda = lazy(() => import('../apps/config/template/Ajuda'));
const Aparencia = lazy(() => import('apps/config/template/Aparencia'));
const HomeArtigo29 = lazy(() => import('../apps/artigo29/HomeArtigo29'));
const Autenticidade = lazy(() => import('apps/autenticidade/Autenticidade'));
const BeneficioIncapacidade = lazy(() => import('../apps/beneficioIncapacidade/BeneficioIncapacidade'));
const BiometriaTeste = lazy(() => import('../apps/biometria/BiometriaTeste'));
const BuscarServico = lazy(() => import('./component/buscarServico'));
const CalendarioPagamento = lazy(() => import("../apps/calendarioPagamento/CalendarioPagamento"));
const Carteira = lazy(() => import('../apps/carteira/Carteira'));
const Cat = lazy(() => import('../apps/cat/Cat'));
const CertidaoTempoContribuicao = lazy(() => import('../apps/certidaoTempoContribuicao/RouterCertidaoTempoContribuicao'));
const CertificadoDeficiencia = lazy(() => import('../apps/certificadoDeficiencia/CertificadoDeficiencia'));
const Concal = lazy(() => import("../apps/concal/Concal"));
const Consignado = lazy(() => import('../apps/bloqDesbloqConsignado/Consignado'));
const ContribuicaoInferior = lazy(() => import('../apps/contribuicaoInferior/ContribuicaoInferior'));
const Crer = lazy(() => import("../apps/crer/Crer"));
const DadosCadastrais = lazy(() => import("../apps/dadosCadastrais/DadosCadastrais"));
const DadosDivergentes = lazy(() => import('apps/naoConformidade/DadosDivergentes'));
const DeclaracaoAtividade = lazy(() => import('../apps/declaracaoAtividade/DeclaracaoAtividade'));
const DownloadChatbot = lazy(() => import('../apps/chatbot/DownloadChatbot'));
const Drsci = lazy(() => import('../apps/drsci/Drsci'));
const EmissaoGPS = lazy(() => import('apps/emissaoGPS/EmissaoGPS'));
const ExtratoConsignado = lazy(() => import('../apps/extratoConsignado/ExtratoConsignado'));
const ExtratoIR = lazy(() => import("../apps/extratoIR/ExtratoIR"));
const ExtratoPrevidenciario = lazy(() => import("../apps/extratoPrevidenciario/ExtratoPrevidenciario"));
const GrupoMenu = lazy(() => import('../painel/GrupoMenu'));
const Hiscre = lazy(() => import("../apps/hiscre/Hiscre"));
const Home = lazy(() => import("./Home"));
const HomeDeclaracaoPpp = lazy(() => import('../apps/declaracaoPpp/HomeDeclaracaoPpp'));
const HomeExtratBeneficio = lazy(() => import('../apps/extratoBeneficio/HomeExtratBeneficio'));
const LaudosMedicosSinc = lazy(() => import("../apps/laudosMedicos/LaudosMedicosSinc"));
const LocalFormaPagamentoBiometria = lazy(() => import('../apps/localFormaPagamento/LocalFormaPagamentoBiometria'));
const LocalizadorAPS = lazy(() => import("../apps/localizadorAPS/LocalizadorAPS"));
const LoginBiometrico = lazy(() => import('login/LoginBiometrico'));
const Mensalidade = lazy(() => import('../apps/bloqDesbloqMensalidade/Mensalidade'));
const MeusBeneficios = lazy(() => import('../apps/meusBeneficios/MeusBeneficios'));
const NadaConsta = lazy(() => import('./../apps/nadaConsta/NadaConsta'));
const NewVersionSwipableReboard = lazy(() => import('newVersionReboarding/NewVersionSwipableReboard'));
const Notificacoes = lazy(() => import('../apps/notificacao/Notificacoes'));
const NovoPedido = lazy(() => import('../apps/novopedido/NovoPedido'));
const NovoPedidoNaoLogadoRouter = lazy(() => import('apps/novopedido/NovoPedidoNaoLogado'));
const PisPasepFGTS = lazy(() => import('../apps/pisPasepFgts/PisPasepFGTS'));
const Acessibilidade = lazy(() => import('apps/acessibilidade/Acessibilidade'));
const PoliticaPrivacidade = lazy(() => import('onBoardScreen/PoliticaPrivacidade'));
const ProcuradorAcessoNegado = lazy(() => import('./component/newdashboard/ProcuradorAcessoNegado'))
const RegistrarDispositivo = lazy(() => import('login/RegistrarDispositivo'));
const Requerimentos = lazy(() => import('../apps/requerimentos/Requerimentos'));
const RouterConfiguracoes = lazy(() => import("../apps/config/RouterConfiguracoes"));
const SeguradoEspecial = lazy(() => import('../apps/requerimentos/seguradoEspecial/SeguradoEspecial'));
const SeloPrevidencia = lazy(() => import('selo-previdencia/SeloPrevidencia'));
const ServicoEmManutencao = lazy(() => import('./component/newdashboard/ServicoEmManutencao'));
const ServicoNaoHabilidado = lazy(() => import("apps/servicoNaoHabilitado/ServicoNaoHabilitado"));
const Servicos = lazy(() => import("apps/servicos/Servicos"));
const Simulador = lazy(() => import("../apps/simulador/Simulador"));
const SituacaoProvaVida = lazy(() => import("../apps/provaVida/SituacaoProvaVida"));
const Sobre = lazy(() => import('../apps/sobre/Sobre'));
const TamanhoFonte = lazy(() => import('apps/config/template/TamanhoFonte'));
const TaxasJuros = lazy(() => import('../apps/taxasJuros/HomeTaxasJuros'));
const TelaErroBeneficioIncapacidade = lazy(() => import('./component/newdashboard/TelaErroBeneficioIncapacidade'));
const TodosServicosNovoPedido = lazy(() => import("../apps/novopedido/TodosServicosNovoPedido"));
const LoadingRequerimentoSag = lazy(() => import('apps/loadingRequerimentoSag'));
const ManutencaoMeuINSS = lazy(() => import('./component/newdashboard/ManutencaoMeuINSS'));
const ConsultarDescontosEntidadesAssociativas = lazy(() => import('apps/entidadesAssociativas/consultarDescontos'));
const FeedbackPage = lazy(() => import('./component/feedback'));

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    height: "100%",
    display: "flex",
    fontSize: "1.1em",
  },
  content: {
    flexGrow: 1,
    flexShrink: 1,
    width: 0,
  },
  appContent: {
    padding: 0,
    paddingBottom: "100px",
    //120px é a soma da toolbar e barra brasil
    minHeight: "calc(100vh - 120px)",
    [theme.breakpoints.down('sm')]: {
      // em tablet a barra brasil some
      minHeight: "calc(100vh - 110px)",
    },
  },
}));


const NovoProtectedAppWrapper = ({
  gestaoIndisponivel, tituloPagina, mensagemErro, feedback, launchExternalLink, msgAcessoProcurador
}) => {

  useCXPageView();

  const dispatch = useDispatch();

  const classes = useStyles();
  const location = useLocation();
  useEffect(() => {
    const handleSkipLinkClick = (event) => {
      const id = (event.currentTarget.hash || '').replace(/^#\/?/, '');
      if (id === "main-content") {
        event.preventDefault();
        const mainContent = document.getElementById("main-content");

        if (mainContent) {
          mainContent.focus();
        }
      }
      else if (id === "busca") {
        event.preventDefault();
        const buscaContent = document.getElementById("downshift-simple-input");

        if (buscaContent) {
          buscaContent.focus();
        }
      }
      else if (id === "footer") {
        event.preventDefault();
        const footerContent = document.getElementById("footer");

        if (footerContent) {
          footerContent.focus();
        }
      }
      else if (id === "menu") {
        event.preventDefault();
        const menuContent = document.getElementById("menu");

        if (menuContent) {
          menuContent.focus();
        }
      }
    };

    const skipLinks = document.querySelectorAll(".br-skiplink a");
    skipLinks.forEach((link) => link.addEventListener("click", handleSkipLinkClick));

    return () => {
      skipLinks.forEach((link) => link.removeEventListener("click", handleSkipLinkClick));
    };
  }, []);

  useEffect(() => {
    if (gestaoIndisponivel && estaLogado() && !location.pathname.startsWith("/aberto/")) {
      history.push('/servico-manutencao');
    }
  }, [gestaoIndisponivel]);

  useExternalLinkHandler(
    { feedback, launchExternalLink }
  );

  const [manutencao, setManutencao] = useState(false);

  useEffect(() => {

    const checkUrl = () => {
      try {
        const regexpString = getConfig("urlsManutencao");
        const regex = regexpString ? new RegExp(regexpString) : null;
        const hash = window.location.hash || "";
        if (regex && regex.test(hash)) {
          setManutencao(true);
        } else {
          setManutencao(false);
        }
      } catch (e) {
        setManutencao(false);
      }
    };

    checkUrl();

    window.addEventListener("hashchange", checkUrl);

    return () => {
      window.removeEventListener("hashchange", checkUrl);
    };
  }, []);

  return (
    <div>
      <CssBaseline />
      <SkipLinkHome />
      <div className="mi-row">
        <div className="mi-col">
          <MIToolbar />
        </div>
        {!isSessaoValida() && <HideHelo />}
        <div className={`mi-col-9 mi-main-content mi-offset-3`}>
          <Container maxWidth={"md"} className={classes.appContent}>
            <>
              <PainelProcurador />
              <Breadcrumb />
              {mensagemErro && <DTPMessage {...mensagemErro} onClose={() => dispatch(setMensagemErro(null))} />}
              {manutencao && <WorkInProgress
                primaryText="Serviço em manutenção."
                action={() => history.goBack()}
                buttonText="Voltar"
                secondaryText='<p>Tente de novo mais tarde. </br>Precisa de ajuda? Acesse o <a href="https://www.gov.br/inss/pt-br/servicos" target="_blank" style="font-size: inherit; color: #1351B4">Portal do INSS</a> ou ligue 135.</p>'
              />}
              {!manutencao && <Suspense fallback={<LoadingCircular />}>
                <Switch>
                  <Route path='/novidades' component={NewVersionSwipableReboard} />
                  <Route path='/registrar-dispositivo' component={RegistrarDispositivo} />
                  <Route title={'Excluir Procurador'} exact path='/requerimentos/detalhar/procurador/excluir' component={() => (
                    <ProcuradorAcessoNegado title={'Excluir Procurador'} />
                  )} />
                  <Route title={'Preencher Autodeclaração'} exact path='/autodeclaracao-ses/:protocolo/preencher' component={() => (
                    <ProcuradorAcessoNegado title={'Preencher Autodeclaração'} />
                  )} />
                  <PrivateRoute title="Autodeclaração Segurado Especial" path="/autodeclaracao-ses/:protocolo" component={SeguradoEspecial} />
                  <PrivateRoute title="Bloquear ou Desbloquear para empréstimo" path="/consignado" component={Consignado} />
                  <PrivateRoute title="Carteira do Beneficiário" path="/carteira" component={Carteira} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Simular Aposentadoria" path="/simulador" component={Simulador} />
                  <PrivateRoute title="Extrato de Contribuições (CNIS)" path="/extrato-previdenciario" component={ExtratoPrevidenciario} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Meu Cadastro" path="/dados-cadastrais" component={DadosCadastrais} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Extrato de Pagamento de Benefício" path="/extrato-beneficio" component={Hiscre} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Encontre uma Agência" path="/localizador-aps" component={LocalizadorAPS} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Extrato de Imposto de Renda" path="/extrato-ir" component={ExtratoIR} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Consultar Pedidos" path="/requerimentos" component={Requerimentos} />
                  <PrivateRoute title="Benefício por Incapacidade" path="/beneficio-incapacidade" component={BeneficioIncapacidade} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Resultado de Benefício por Incapacidade" path="/crer" component={Crer} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Carta de Concessão de Benefício" path="/concal" component={Concal} />
                  <PrivateRoute title="Consultar Revisão de Benefício - Artigo 29" path="/artigo29" component={HomeArtigo29} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Declaração de Regularidade da Situação do Contribuinte Individual (DRSCI)" path="/drsci" component={Drsci} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Extrato de Empréstimos" path="/extrato-consignado" component={ExtratoConsignado} />
                  <PrivateRoute title="Taxas de Empréstimo Consignado" path="/taxas-juros" component={TaxasJuros} />
                  <PrivateRoute title="Cálculo de GPS Diferença de Valor Devido - Contribuição Inferior ao Salário Mínimo" path="/cism" component={ContribuicaoInferior} />
                  <PrivateRoute title="Declaração de Beneficiário do INSS" path="/nada-consta" component={NadaConsta} />
                  <PrivateRoute title="Declaração de Atividade" path="/declaracao-atividade" component={DeclaracaoAtividade} />
                  <PrivateRoute title="Certificado da Pessoa com Deficiência" path="/certificado-deficiencia" component={CertificadoDeficiencia} />
                  <PrivateRoute title="Certidão de Tempo de Contribuição (CTC)" path="/certidao-contribuicao" component={CertidaoTempoContribuicao} />
                  <PrivateRoute title="Meus Benefícios" path="/meus-beneficios" component={MeusBeneficios} />
                  <PrivateRoute title="Laudo Médico e Avaliação Social" path="/laudos-medicos" component={LaudosMedicosSinc} />
                  <PrivateRoute title="Grupo de Serviços" path="/grupo" component={GrupoMenu} />
                  <PrivateRoute title="Calendário de Pagamento" path="/calendario-pagamento" component={CalendarioPagamento} />
                  <PrivateRoute title='Sobre o Meu INSS' path="/sobre" component={Sobre} />
                  <PrivateRoute title="Prova de Vida" path="/situacao-prova-vida" component={SituacaoProvaVida} />
                  <PrivateRoute tituloDinamico={true} title="Notificações" path="/notificacoes" component={Notificacoes} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Extrato de Informações do Benefício" path="/dossie-previdenciario" component={HomeExtratBeneficio} />
                  <PrivateRoute title="Comunicação de Acidente de Trabalho (CAT)" path="/cat" component={Cat} />
                  <PrivateRoute title='Certidão para Saque do PIS / PASEP / FGTS' path="/fgts" component={PisPasepFGTS} />
                  <PrivateRoute title="Download de Documento" path="/download/:arquivo" component={DownloadChatbot} />
                  <PrivateRoute title="Biometria" path="/biometria" component={BiometriaTeste} />
                  <PrivateRoute title="PPP Eletrônico - Perfil Profissiográfico Previdenciário" path="/declaracao-ppp" component={HomeDeclaracaoPpp} />
                  <PrivateRoute title="Alterar Local ou Forma de Pagamento" path="/local-forma-pagamento-biometria" component={LocalFormaPagamentoBiometria} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Mensalidade Associativa" path="/mensalidade-entidade" component={Mensalidade} />
                  <PrivateRoute title="Buscar Serviço" path="/buscar-servico" component={BuscarServico} />
                  <PrivateRoute title="Mais Serviços" path="/servicos" component={Servicos} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Meu Perfil" path="/configuracoes" component={RouterConfiguracoes} />
                  <PrivateRoute breadcrumbProps={{ parent: '/novo-pedido' }} title="Todos os Serviços" path="/novo-pedido-servicos" component={TodosServicosNovoPedido} />
                  <PrivateRoute tituloDinamico={true} path="/servico-nao-habilitado" component={ServicoNaoHabilidado} />
                  <PrivateRoute tituloDinamico={true} path="/carregar-requerimento-sag" component={LoadingRequerimentoSag} />
                  <PrivateRoute path="/entidades-associativas" component={ConsultarDescontosEntidadesAssociativas} />
                  <Route title={tituloPagina} path='/tela-erro-beneficio-incapacidade' component={() => (
                    <TelaErroBeneficioIncapacidade title={tituloPagina} />
                  )} />
                  <Route breadcrumbProps={{ skip: true }} title="Autenticidade de Documentos" path='/aberto/autenticidade' component={Autenticidade} />
                  <PrivateRoute breadcrumbProps={{ skip: true }} title="Novo Pedido" path="/novo-pedido" component={NovoPedido} />
                  <Route title="Novo Pedido" path='/aberto/novo-pedido' component={NovoPedidoNaoLogadoRouter} />
                  <Route breadcrumbProps={{ skip: true }} title="Encontre uma Agência" path='/aberto/localizador-aps' component={LocalizadorAPS} />
                  <Route title='Sobre o Meu INSS' path='/aberto/sobre' component={Sobre} />
                  <Route title="Ajuda" path='/aberto/ajuda' component={Ajuda} />
                  <Route title="Calendário de Pagamento" path='/aberto/calendario-pagamento' component={CalendarioPagamento} />
                  <Route title="Taxas de Empréstimo Consignado" path='/aberto/taxas-juros' component={TaxasJuros} />
                  <Route title="Serviço em Manutenção" path='/aberto/servico-manutencao' component={ServicoEmManutencao} />
                  <Route title="Política de Privacidade do Meu INSS" path='/aberto/politica' component={PoliticaPrivacidade} />
                  <Route title="Acessibilidade" path='/aberto/acessibilidade' component={Acessibilidade} />
                  <Route title="Selo Previdenciário" path='/selo-previdencia' component={SeloPrevidencia} />
                  <Route title="Login Biométrico" path='/aberto/login-biometrico' component={LoginBiometrico} />
                  <Route title="Tamanho da Fonte" path='/aberto/tamanho-fonte' component={TamanhoFonte} />
                  <Route title="Aparência da Tela" path='/aberto/contraste' component={Aparencia} />
                  <Route title="Dados Divergentes" path='/dados-divergentes' component={DadosDivergentes} />
                  <Route title="Emissão da Guia de Pagamento (GPS)" path='/aberto/emissao-gps' component={EmissaoGPS} />
                  <Route title={tituloPagina} path='/acesso-negado-proc'
                    component={() => (
                      <ProcuradorAcessoNegado title={tituloPagina} msg={msgAcessoProcurador} />
                    )} />
                  <Route title="Manutenção" path='/aberto/manutencao' component={ManutencaoMeuINSS} />
                  <Route breadcrumbProps={{ enabled: false }} path="/aberto/tela-info" component={FeedbackPage} />
                  <PrivateRoute title="Meu INSS" exact path="/" component={Home} />
                  <Route
                    title="Serviço não encontrado"
                    path="*"
                    render={() => (
                      <ServicoNaoEncontradoScreen
                        action={() => history.replace('/')}
                      />
                    )}
                  />
                </Switch>
              </Suspense>}
            </>
          </Container>
        </div>
      </div>
    </div>
  );
};

//Não usar useSelection pois estava cusando comportamentos estranhos. Optei por manter assim mesmo.
const mapStateToProps = (state) => ({
  gestaoIndisponivel: state.app.gestaoIndisponivel,
  tituloPagina: state.app.tituloPagina,
  mensagemErro: state.app.mensagemErro,
  feedback: state.feedback,
  launchExternalLink: state.app.launchExternalLink,
  msgAcessoProcurador: state.app.msgAcessoProcurador,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NovoProtectedAppWrapper);
